@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../constants/spacing.module.less';

.card-container {
  position: relative;
  border: 1px var(--default--border-color--10) solid;
  border-radius: 8px;
  padding: 16px;
  background-color: var(--white);

  &.clickable {
    padding: 0;
    &:hover {
      background: var(--banner-message--info-background-color--2);
      border: 1px solid var(--primary--button--hover--border-color--2);
      border-radius: 8px;
      cursor: pointer;
    }
  }
  &.payment-card {
    padding: @space-16 @space-0;
  }
}

.overlay {
  position: absolute;
  background-color: var(--light--background-color--1);
  opacity: 0.5;
  margin: -16px; // accounts for absolute + padding
  height: 100%;
  width: 100%;
}
